import dackarnaLogo from "@/assets/teams/Dackarna-150x150.png";
import indianernaLogo from "@/assets/teams/Indianerna-150x150.png";
import lejonenLogo from "@/assets/teams/lejonen-150x150.png";
import piraternaLogo from "@/assets/teams/Piraterna-speedway-150x150.png";
import rospiggarnaLogo from "@/assets/teams/Rospiggarna-150x150.png";
import smedernaLogo from "@/assets/teams/Smederna-Logga-150x150.png";
import vargarnaLogo from "@/assets/teams/Vargarna-logo-150x150.png";
import vastervikLogo from "@/assets/teams/Vastervik_Speedway-150x150.png";

function normalizeTeamName(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ");
}

const teamAliases = {
  Dackarna: ["Dackarna", "Dackarna Malilla", "Dackarna Målilla"],
  Indianerna: ["Indianerna", "Indianerna Kumla"],
  Lejonen: ["Lejonen", "Lejonen Gislaved"],
  Piraterna: ["Piraterna", "Piraterna Motala"],
  Rospiggarna: ["Rospiggarna", "Rospiggarna Hallstavik"],
  Smederna: ["Smederna", "Smederna Eskilstuna"],
  Vargarna: ["Vargarna", "Vargarna Norrkoping", "Vargarna Norrköping"],
  Västervik: ["Västervik", "Vastervik", "Västervik Speedway", "Vastervik Speedway"],
};

const logosByName = {
  Dackarna: dackarnaLogo,
  Indianerna: indianernaLogo,
  Lejonen: lejonenLogo,
  Piraterna: piraternaLogo,
  Rospiggarna: rospiggarnaLogo,
  Smederna: smedernaLogo,
  Vargarna: vargarnaLogo,
  Västervik: vastervikLogo,
};

const logosByNormalizedName = Object.entries(teamAliases).reduce((acc, [canonicalName, aliases]) => {
  const logo = logosByName[canonicalName];
  aliases.forEach((alias) => {
    acc[normalizeTeamName(alias)] = logo;
  });
  return acc;
}, {});

export function getTeamLogo(teamName) {
  return logosByNormalizedName[normalizeTeamName(teamName)] || null;
}

export { logosByName };
